module.exports = __webpack_public_path__ + "static/media/soundcloud.0cdfee68.svg";